import API from '../api';
import repositoryHelper from '../helpers/RepositoryHelper';
import ZoneForm from '../models/form/ZoneForm';
import ZoneView from '../models/view/ZoneView';
import PresentListUserView from '../models/view/PresentListUserView';

export default () => ({
    browseAdmin(roomId) {
        return API.get(`/api/admin/zone/${roomId}/all`)
            .then(response => API.handle(response))
            .catch(API.error)
            .then(raw => raw.map(singleRaw => new ZoneForm(singleRaw)));
    },
    read(zoneId) {
        return API.get(`/api/zone/get/${zoneId}`)
            .then(response => API.handle(response))
            .catch(API.error)
            .then(json => new ZoneForm(json));
    },
    readAdmin(zoneId) {
        return API.get(`/api/admin/zone/get/${zoneId}`)
            .then(API.handle)
            .catch(API.error)
            .then(json => new ZoneForm(json));
    },
    deleteAdmin(zoneId) {
        return API.delete(`/api/admin/zone/${zoneId}`)
            .then(response => API.handle(response))
            .catch(API.error);
    },
    edit(zone, authorizationGroups) {
        zone.dimensions = JSON.stringify(zone.dimensions);
        const data = {...zone, authorizationGroups};

        return API.postJSON(`/api/admin/zone/${zone.id}/edit`, data)
            .then(response => API.handle(response))
            .catch(API.error);
    },
    add(zone, authorizationGroups) {
        zone.dimensions = JSON.stringify(zone.dimensions);
        const data = {
            id: zone.id,
            name: zone.name,
            dimensions: zone.dimensions,
            capacity: zone.capacity,
            room: zone.room,
            blocked: zone.blocked,
            characteristics: zone.characteristics,
            authorizationGroups,
        };

        return API.postJSON('/api/admin/zone/create', data)
            .then(response => API.handle(response))
            .catch(API.error)
            .then(raw => new ZoneView(raw));
    },
    addMultiple(zones) {
        if (zones.length === 0) {
            return Promise.resolve({created: [], errors: []});
        }

        const roomId = zones[0].room;
        const resources = zones.map(item => ({
            resourceTypeId: 'e1ac2a75-cbfd-4e0a-b8f4-a4cbce331f7a', // ResourceType::GLOBAL_ZONE
            name: item.name || null,
            dimensions: JSON.stringify(item.dimensions),
            capacity: item.capacity || 10,
            characteristics: item.characteristics || [],
            blocked: item.blocked || false,
            calendarResourceId: item.calendarResourceId || null,
            authorizationGroups: item.authorizationGroups || null,
        }));

        return API.postJSON(`/api/admin/resource/createMultiple/${roomId}`, {resources})
            .then(API.handle)
            .catch(API.error);
    },
    delete(zoneDayBookingId) {
        return API.delete(`/api/zoneDayBookings/${zoneDayBookingId}/delete`)
            .then(response => API.handle(response))
            .catch(API.error);
    },
    getNextAvailableZoneName(roomId) {
        return API.get(`/api/zone/${roomId}/nextAvailableZoneName`)
            .then(response => API.handle(response))
            .catch(API.error);
    },
    filter(location, room, characteristics, days, timeframe, from, until) {
        const url = repositoryHelper.methods.createFilterUrl(
            '/api/zone/filter',
            location,
            room,
            characteristics,
            days,
            timeframe,
            from,
            until
        );

        return API.get(url)
            .then(response => API.handle(response))
            .catch(API.error)
            .then(raw => ({
                zones: raw.zones.map(singleRaw => new ZoneView(singleRaw)),
                roomAvailableZones: raw.roomAvailableZones,
            }));
    },
    getUsers(zoneId, date) {
        return API.get(`/api/zone/users/${zoneId}/${date}`).then(response => {
            return response.json();
        });
    },
    getUsersForDates(zoneId, dates) {
        const searchParams = new URLSearchParams();

        searchParams.append('zone', zoneId);
        dates.forEach(date => searchParams.append('dates[]', date));

        return API.get(`/api/zone/users?${searchParams.toString()}`)
            .then(API.handle)
            .catch(API.error)
            .then(raw => raw.map(singleRaw => new PresentListUserView(singleRaw)));
    },
});
